import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import RbAccountModalComponent from '../components/rb-account-modal/rb-account-modal.jsx';

import {closeAccountModal} from '../reducers/modals';
import {updateStatus} from '../reducers/connection';
import {updateRecord} from '../reducers/account.js';

class RbAccountModal extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleCancel',
            'handleActivateTab',
            'handleLogin',
            'handleSignUp',
            'handleLoginEmail',
            'handleLoginPassword',
            'handleSignupUsername',
            'handleSignupEmail',
            'handleSignupPassword'
        ]);
        this.state = {
            activeTabIndex: 0,
            loginEmail: '',
            loginEmailIsValid: true,
            loginPassword: '',
            loginPasswordIsValid: true,
            loginMessage: '',
            signupUsername: '',
            signupUsernameIsValid: true,
            signupEmail: '',
            signupEmailIsValid: true,
            signupPassword: '',
            signupPasswordIsValid: true,
            signupMessage: ''
        };
    }

    componentDidMount () {

    }

    handleCancel (e) {
        e.stopPropagation();
        this.props.onClose();
    }

    handleActivateTab (index) {
        this.setState({
            activeTabIndex: index
        });
    }

    handleLoginEmail (event) {
        const email = event.target.value;
        if (/\S+@\S+\.\S+/.test(email)) {
            this.setState({
                loginEmailIsValid: true
            });
        } else {
            this.setState({
                loginEmailIsValid: false
            });
        }
        this.setState({
            loginEmail: email
        });
    }

    handleLoginPassword (event) {
        const loginPassword = event.target.value;
        if (/^([\s\S]){6,16}$/.test(loginPassword)) {
            this.setState({
                loginPasswordIsValid: true
            });
        } else {
            this.setState({
                loginPasswordIsValid: false
            });
        }
        this.setState({
            loginPassword: loginPassword
        });
    }

    handleSignupUsername (event) {
        const username = event.target.value;
        if (/^([a-zA-Z0-9_-]){6,16}$/.test(username)) {
            this.setState({
                signupUsernameIsValid: true
            });
        } else {
            this.setState({
                signupUsernameIsValid: false
            });
        }
        this.setState({
            signupUsername: username
        });
    }

    handleSignupEmail (event) {
        const email = event.target.value;
        if (/\S+@\S+\.\S+/.test(email)) {
            this.setState({
                signupEmailIsValid: true
            });
        } else {
            this.setState({
                signupEmailIsValid: false
            });
        }
        this.setState({
            signupEmail: email
        });
    }

    handleSignupPassword (event) {
        const password = event.target.value;
        if (/^([\s\S]){6,16}$/.test(password)) {
            this.setState({
                signupPasswordIsValid: true
            });
        } else {
            this.setState({
                signupPasswordIsValid: false
            });
        }
        this.setState({
            signupPassword: password
        });
    }

    handleLogin () {
        const data = {
            email: this.state.loginEmail,
            password: this.state.loginPassword
        };
        if (/\S+@\S+\.\S+/.test(this.state.loginEmail) === false) {
            this.setState({
                loginEmailIsValid: false
            });
        }
        if (/^([\s\S]){6,16}$/.test(this.state.loginPassword) === false) {
            this.setState({
                loginPasswordIsValid: false
            });
        }
        if (/\S+@\S+\.\S+/.test(this.state.loginEmail) && /^([\s\S]){6,16}$/.test(this.state.loginPassword)) {
            fetch('http://accounts.robobloq.com/api/v1/login', {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json())
                .then(response => {
                    if (response.success) {
                        this.props.onUpdateAccountRecord(JSON.stringify(response));
                    } else {
                        this.setState({
                            loginMessage: response.message
                        });
                        setTimeout(() => {
                            this.setState({
                                loginMessage: ''
                            });
                        }, 3000);
                    }
                })
                .catch(error => {
                    throw error;
                });
        }
    }

    handleSignUp () {
        const data = {
            username: this.state.signupUsername,
            email: this.state.signupEmail,
            password: this.state.signupPassword
        };
        if (/^([a-zA-Z0-9_-]){6,16}$/.test(this.state.signupUsername) === false) {
            this.setState({
                signupUsernameIsValid: false
            });
        }
        if (/\S+@\S+\.\S+/.test(this.state.signupEmail) === false) {
            this.setState({
                signupEmailIsValid: false
            });
        }
        if (/^([\s\S]){6,16}$/.test(this.state.signupPassword) === false) {
            this.setState({
                signupPasswordIsValid: false
            });
        }
        if (/^([a-zA-Z0-9_-]){6,16}$/.test(this.state.signupUsername) &&
            /\S+@\S+\.\S+/.test(this.state.signupEmail) &&
            /^([\s\S]){6,16}$/.test(this.state.signupPassword)
        ) {
            fetch('http://accounts.robobloq.com/api/v1/signup', {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json())
                .then(response => {
                    if (response.success) {
                        this.props.onUpdateAccountRecord(JSON.stringify(response));
                    } else {
                        this.setState({
                            signupMessage: response.message
                        });
                        setTimeout(() => {
                            this.setState({
                                signupMessage: ''
                            });
                        }, 3000);
                    }
                })
                .catch(error => {
                    throw error;
                });
        }
    }

    render () {
        return (
            <RbAccountModalComponent
                activeTabIndex={this.state.activeTabIndex}
                loginEmail={this.state.loginEmail}
                loginEmailIsValid={this.state.loginEmailIsValid}
                loginMessage={this.state.loginMessage}
                loginPassword={this.state.loginPassword}
                loginPasswordIsValid={this.state.loginPasswordIsValid}
                signupEmail={this.state.signupEmail}
                signupEmailIsValid={this.state.signupEmailIsValid}
                signupMessage={this.state.signupMessage}
                signupPassword={this.state.signupPassword}
                signupPasswordIsValid={this.state.signupPasswordIsValid}
                signupUsername={this.state.signupUsername}
                signupUsernameIsValid={this.state.signupUsernameIsValid}
                onActivateTab={this.handleActivateTab}
                onCancel={this.handleCancel}
                onChangeLoginEmail={this.handleLoginEmail}
                onChangeLoginPassword={this.handleLoginPassword}
                onChangeSignupEmail={this.handleSignupEmail}
                onChangeSignupPassword={this.handleSignupPassword}
                onChangeSignupUsername={this.handleSignupUsername}
                onLogin={this.handleLogin}
                onSignUp={this.handleSignUp}
            />
        );
    }
}

RbAccountModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onUpdateAccountRecord: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    onClose: () => {
        dispatch(closeAccountModal());
    },
    onUpdateStatus: status => {
        dispatch(updateStatus(status));
    },
    onUpdateAccountRecord: record => {
        dispatch(updateRecord(record));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RbAccountModal);
